/* eslint-disable import/prefer-default-export */
export enum LeadStatus {
  WON = 1,
  LOST = 2,
  CHRONO = 1,
}
